import React, { Component } from "react";
import { connect } from "react-redux";
import FilterPlanning from "./FilterContainer";
import FilterType from "./FilterContainerType";
import AuthRender from "../../AuthRender";
import { Select } from "antd";
import { updatePlanningFilters } from "../../../redux/actions/planningActions";
import { PLANNING_SELECT_PDC_ID } from "../../../redux/types";

class Filters extends Component {
  render() {
    return (
      <div className="p-al-left p-al-wrap">
        <AuthRender minRole={3}>
          <div className="p-mrg-right p-mrg-bot-s" style={{ width: 150 }}>
            <FilterPlanning
              filterTargetKey={"email"}
              placeholder={"Utilisateurs"}
              mode={"default"}
              defaultValue={this.props.selectedEmail}
              allowClear={false}
            />
          </div>
        </AuthRender>
        <div key={"sector_label"} className="p-mrg-right p-mrg-bot-s" style={{ width: 150 }}>
          <FilterPlanning
            filterTargetKey={"sector_label"}
            placeholder={"Secteurs"}
            mode={"default"}
            defaultValue={this.props.selectedSector}
            allowClear={true}
          />
        </div>

        <div className="p-mrg-right p-mrg-bot-s" style={{ width: 150 }}>
          <Select
            style={{ width: "100%" }}
            placeholder={"PDCs"}
            allowClear={true}
            showSearch
            value={this.props.selectedPdcId}
            onChange={value => {
              this.props.setSelectedPdcId(value);
              this.props.updateFilters("pdc_id", value);
            }}
            filterOption={(input, option) => {
              return typeof option.props.children === "string"
                ? option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                : false;
            }}
          >
            {this.props.userPdcs.map(item => (
              <Select.Option key={item["pdc_id"]} value={item["pdc_id"]}>
                {item["pdc_label"]}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div className="p-mrg-right p-mrg-bot-s" style={{ width: 150 }}>
          <FilterType
            filterTargetKey="type"
            placeholder="Types d'évènement"
            mode="default"
            defaultValue={this.props.selectedTypeVisit}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    selectedEmail: state.planning.selectedEmail,
    selectedPdc: state.planning.selectedPdc,
    selectedPdcId: state.planning.selectedPdcId,
    selectedSector: state.planning.selectedSector,
    selectedTypeVisit: state.planning.selectedTypeVisit,
    userPdcs: state.planning.userPdcs || []
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateFilters: (key, value) => dispatch(updatePlanningFilters(key, value)),
    setSelectedPdcId: pdcId => dispatch({ type: PLANNING_SELECT_PDC_ID, payload: pdcId })
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Filters);



// WEBPACK FOOTER //
// src/containers/activite/planning/Filters.js